import { discountConstants } from '../_constants';

//-- add discount settings reducer
export function addDiscount(state = {}, action) {
  switch (action.type) {
    case discountConstants.DISCOUNT_ADD_SETTINGS_REQUEST:
      return {
        discountAdd: false
      };

    case discountConstants.DISCOUNT_ADD_SETTINGS_SUCCESS:      
      return { discountAdd:action.successAction};

    case discountConstants.DISCOUNT_ADD_SETTINGS_FAILURE:
      return {
        discountAdd: false,
      };

    default:
      return state
  }
}
  


// //-- get discount record reducer
export function getDiscountSettings(state = {}, action) {
    switch (action.type) {
      case discountConstants.DISCOUNT_GET_SETTINGS_REQUEST:
        return {
          discGet: false
        };
  
      case discountConstants.DISCOUNT_GET_SETTINGS_SUCCESS:        
        return { discGet:action.successAction};
  
      case discountConstants.DISCOUNT_GET_SETTINGS_FAILURE:
        return {
          discGet: false,
        };
  
      default:
        return state
    }
  }


  

//-- edit a discount  
export function editDiscounts(state = {}, action) {
  switch (action.type) {
    case discountConstants.DISCOUNT_EDIT_SETTINGS_REQUEST:
      return {
        discEdit: false
      };

    case discountConstants.DISCOUNT_EDIT_SETTINGS_SUCCESS:      
      return { discEdit:action.successAction};

    case discountConstants.DISCOUNT_EDIT_SETTINGS_FAILURE:
      return {
        discEdit: false,
      };

    default:
      return state
  }
 }



//-- delete a discount settings 
export function deleteDiscount(state = {}, action) {
  switch (action.type) {
    case discountConstants.DISCOUNT_DELETE_SETTINGS_REQUEST:
      return {
        discDelete: false
      };

    case discountConstants.DISCOUNT_DELETE_SETTINGS_SUCCESS:      
      return { discDelete:action.successAction};

    case discountConstants.DISCOUNT_DELETE_SETTINGS_FAILURE:
      return {
        discDelete: false,
      };

    default:
      return state
  }
}


//-- get active discount record reducer
export function activeDiscount(state = {}, action) {
  switch (action.type) {
    case discountConstants.GET_ACTIVE_DISCOUNT_REQUEST:
      return { discGet: false };

    case discountConstants.GET_ACTIVE_DISCOUNT_SUCCESS:        
      return { discGet:action.successAction};

    case discountConstants.GET_ACTIVE_DISCOUNT_FAILURE:
      return { discGet: false, };

    default:
      return state
  }
}